<template>
  <ButtonComponent type="button" class="kvass-media-types-youtube-create-trigger">
    <span>YouTube</span>
    <Icon :icon="['fab', 'youtube']" class="ml-1"></Icon>
  </ButtonComponent>
</template>

<script>
import Icon from '@kvass/vue2-icon'
export default {
  components: {
    Icon,
  },
}
</script>

<style lang="scss">
.kvass-media-types-youtube-create-trigger {
  padding: 1rem 0;

  svg {
    color: #fe0002;
  }
}
</style>
